import styled from 'styled-components';

const Input = styled.input`
    box-shadow: none;
    border: 0;
    border-radius: 0;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 100%;

    &:disabled {
        box-shadow: none;
        border-radius: 0;
        background: none;
        color: #666666;
        -webkit-text-fill-color: #666666;
        opacity: 1; /* required on iOS */

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    &:focus {
        outline: none;
    }
`;

export default Input;
